import { render, staticRenderFns } from "./SensorTab.vue?vue&type=template&id=05d56f68&scoped=true"
import script from "./SensorTab.vue?vue&type=script&lang=js"
export * from "./SensorTab.vue?vue&type=script&lang=js"
import style0 from "./SensorTab.vue?vue&type=style&index=0&id=05d56f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d56f68",
  null
  
)

export default component.exports